import config from "config/config";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import { useAuth } from "context";
import { Outlet } from "react-router-dom";
import { setupAxios } from "./core/AuthHelper";
import MDSnackbar from "components/MDSnackbar";

import React, { useEffect } from "react";
import { ErrorBoundary } from "./bugsnagConfig";

import TagManager from "react-gtm-module";

const App = () => {
  const gtmId = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].GTM_ID;
  const { darkMode, logout, snackbarMessage, showSnackbar, saveAuthData } = useAuth();
  useEffect(() => {
    if (gtmId) {
      TagManager.initialize({ gtmId });
    }

    setupAxios(saveAuthData, logout);
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        {!!snackbarMessage.type && (
          <MDSnackbar
            color={snackbarMessage.type === "error" ? "error" : "success"}
            icon={snackbarMessage.type === "error" ? "error" : "checkcircle"}
            title={snackbarMessage.type === "error" ? "Error" : "Success"}
            content={snackbarMessage.message}
            open={showSnackbar}
            bgWhite
          />
        )}
        <CssBaseline />
        {/* GTM noscript fallback */}
        {gtmId && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
              height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
            }}
          />
        )}
        <Outlet />
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
